import { createContext, useContext, useState, useMemo } from 'react';
import { useKeyboardNavigation } from './hooks/useKeyboardNavigation';
const Context = createContext({});
export const useCalendar = () => useContext(Context);
export function Provider(props) {
    const { children, onChange, value = new Date(), locale, timeZone, weekStartsOn = 0, min, max, onFocus, onBlur, onKeyDown, } = props;
    const [focusedDate, setFocusedDate] = useState(value);
    const [focusedYear, setFocusedYear] = useState(focusedDate);
    const [yearPickerVisible, setYearPickerVisible] = useState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const toggleYearPicker = () => setYearPickerVisible((prevState) => !prevState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const hideYearPicker = () => setYearPickerVisible(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const showYearPicker = () => setYearPickerVisible(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const selectYear = (date) => {
        setFocusedDate(date);
        setFocusedYear(date);
        hideYearPicker();
    };
    const { handleKeyDown } = useKeyboardNavigation({
        onKeyDown,
        focusedDate,
        setFocusedDate,
        focusedYear,
        setFocusedYear,
        yearPickerVisible,
    });
    const context = useMemo(() => ({
        focusedDate,
        setFocusedDate,
        value,
        onChange,
        locale,
        timeZone,
        weekStartsOn,
        min,
        max,
        onFocus,
        onBlur,
        onKeyDown: handleKeyDown,
        yearPickerVisible,
        toggleYearPicker,
        hideYearPicker,
        showYearPicker,
        selectYear,
        focusedYear,
        setFocusedYear,
    }), [
        focusedDate,
        setFocusedDate,
        value,
        onChange,
        locale,
        timeZone,
        weekStartsOn,
        min,
        max,
        onFocus,
        onBlur,
        handleKeyDown,
        yearPickerVisible,
        toggleYearPicker,
        hideYearPicker,
        showYearPicker,
        selectYear,
        focusedYear,
        setFocusedYear,
    ]);
    return <Context.Provider value={context}>{children}</Context.Provider>;
}
